<template>
  <v-slide-y-reverse-transition>
    <aside v-if="individualQmpsCardVisible" class="individual-qmps-card">
      <v-card class="round-card elevation-10">
        <v-container class="pt-3 pb-2 px-3">
          <!-- Title -->
          <v-layout class="mb-3" justify-center>
            <v-flex class="title blue-grey--text font-weight-medium" shrink>Crear QMPs individuales</v-flex>
          </v-layout>
          <!-- Instructions -->
          <v-layout class="my-2">
            <v-flex class="blue-grey--text font-weight-light">
              Ahora puedes seleccionar todos los items que quieras y para cada uno se crearán QMPs distintos,
              no solo un QMP para todos los seleccionados.
            </v-flex>
          </v-layout>
          <!-- Action buttons -->
          <v-layout justify-space-around>
            <v-flex shrink>
              <v-btn @click="setIndividualQmpsCardVisible(false)" color="red" flat small>Cancelar</v-btn>
            </v-flex>
            <v-flex shrink>
              <v-btn
                @click="createQmps"
                color="green"
                :dark="!!selectedItems.length"
                :disabled="selectedItems.length === 0"
                small
              >
                <span class="mr-2">Crear {{ selectedItems.length }} QMPs</span>
                <v-icon>check</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </aside>
  </v-slide-y-reverse-transition>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const {
  mapActions,
  mapGetters,
  mapMutations,
  mapState
} = createNamespacedHelpers("matching");

/**
 * This component renders a card with the instructions to create individuals QMPs
 * for the selected items.
 */
export default {
  computed: {
    ...mapGetters(["pivotItem"]),
    ...mapState(["individualQmpsCardVisible", "selectedItems"]),

    brand() {
      return this.$route.params.brandName;
    },

    classificationId() {
      return this.$route.params.classificationId;
    }
  },
  methods: {
    ...mapActions(["createProductWithSingleItem", "getSimilarItems"]),
    ...mapMutations(["clearSelectedItems", "setIndividualQmpsCardVisible"]),
    /**
     * Create the QMP for each item in the selectedItems array.
     */
    createQmps() {
      Promise.all(
        this.selectedItems.map(item =>
          this.createProductWithSingleItem({
            classificationId: this.classificationId,
            item,
            getSimilarItemsAgain: false
          })
        )
      ).then(() => {
        this.clearSelectedItems();
        this.setIndividualQmpsCardVisible(false);
        this.getSimilarItems({
          brand: this.brand,
          classificationId: this.classificationId,
          page: 1,
          sellerId: this.pivotItem.sellerId,
          historyId: this.pivotItem.historyId
        });
      });
    }
  }
};
</script>

<style scoped>
.individual-qmps-card {
  position: fixed;
  top: 10px;
  left: 50%;
  width: 500px;
  margin-left: -250px;
  z-index: 2;
}

@media screen and (max-width: 550px) {
  .individual-qmps-card {
    width: 90vw;
    margin-left: -45vw;
  }
}

.round-card {
  border-radius: 15px;
}
</style>